import React, { useContext } from "react";
import { CautionIcon, PlusIcon, RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import { AppManContext } from "../../../RoundManContext";
import { useTranslation } from "react-i18next";

const ProFourExternal = () => {
	const { t } = useTranslation();
	const {
		check,
		setCheck,
		addProSteps,
		setAddProSteps,
		additionOutSourcing,
		setAdditionOutSourcing,
	} = useContext(AppManContext);

	const handleRemoveOutSourcing = (idx) => {
		const newData = additionOutSourcing.filter((d, index) => index !== idx);
		setAdditionOutSourcing(newData);
	};

	const handleAddOutSourcing = () => {
		setAdditionOutSourcing([
			...additionOutSourcing,
			{ userIdx: 0, role: "심사참여", external: true, email: "", name: "", id: "", pw: "" },
		]);
	};

	const handleNameInputChange = (e, idx) => {
		const newData = additionOutSourcing.map((d, index) =>
			index === idx ? { ...d, name: e.target.value } : d
		);
		setAdditionOutSourcing(newData);
	};

	const handleIdInputChange = (e, idx) => {
		const newData = additionOutSourcing.map((d, index) =>
			index === idx ? { ...d, id: e.target.value } : d
		);
		setAdditionOutSourcing(newData);
	};

	const handlePasswordInputChange = (e, idx) => {
		const newData = additionOutSourcing.map((d, index) =>
			index === idx ? { ...d, pw: e.target.value } : d
		);
		setAdditionOutSourcing(newData);
	};

	const handleEmailInputChange = (e, idx) => {
		const newData = additionOutSourcing.map((d, index) =>
			index === idx ? { ...d, email: e.target.value } : d
		);
		setAdditionOutSourcing(newData);
	};

	const moveToNextStep = () => {
		setAddProSteps(addProSteps + 1);
	};

	const moveToPrevStep = () => {
		setAddProSteps(addProSteps - 1);
	};

	return (
		<>
			<div className="modal-content externalJudgeSetup">
				<div className="setup-header">
					<div className="title-wrap">
						<p className="desc">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.title"
							)}
						</p>
					</div>
					<label className="switch">
						<input type="checkbox" checked={check} onClick={() => setCheck(!check)} />
						<span className="slider round" />
						<span className="slider-label">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.label"
							)}
						</span>
					</label>
				</div>
				<div className="c__card setup-card">
					{check ? (
						<>
							<button
								type="button"
								className="dashed-btn plus-btn"
								onClick={handleAddOutSourcing}
							>
								<PlusIcon />
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.button01"
								)}
							</button>
							{additionOutSourcing.map((d, idx) => {
								return (
									<div className="scroll-wrap" key={idx}>
										<div className="f__group-row">
											<div className="f__group">
												<div className="f__control">
													<input
														type="text"
														className="c__input external-name"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.namePlaceholder"
														)}
														value={d.name}
														onChange={(e) =>
															handleNameInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__control">
													<input
														type="text"
														className="c__input external-id"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.idPlaceholder"
														)}
														value={d.id}
														onChange={(e) =>
															handleIdInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__control">
													<input
														type="password"
														className="c__input external-pw"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.pwPlaceholder"
														)}
														value={d.pw}
														onChange={(e) =>
															handlePasswordInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__control">
													<input
														type="email"
														className="c__input external-email"
														value={d.email}
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.emailPlaceholder"
														)}
														onChange={(e) =>
															handleEmailInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<button
												type="button"
												className="btn-round-delete"
												onClick={() => handleRemoveOutSourcing(idx)}
											>
												<RoundMinusIcon />
											</button>
										</div>
									</div>
								);
							})}
						</>
					) : (
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.noDataTitle"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.noDataText"
								)}
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="gray" onClick={moveToPrevStep}>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					// onClick={showJudgeDateAlert}
					// onClick={showConfirmAlert}
					// onClick={showExternalAlert}
					onClick={moveToNextStep}
				>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.next")}
				</button>
				{/*<button*/}
				{/*	type="button"*/}
				{/*	className="btn__solid"*/}
				{/*	color="primary"*/}
				{/*	onClick={() => setEvaluateSetupModal(false)}*/}
				{/*>*/}
				{/*	확인*/}
				{/*</button>*/}
			</div>
		</>
	);
};

export default ProFourExternal;
